import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../_models/api-response.model';
import { ReportModel, ChartUrls } from '../_models/report.model';
import { SettingsService } from './settings.service';


@Injectable()
export class ReportService {
  public apiEndPoint: string; // = environment.SPECTRUM_API;
  key = environment.API_KEY as unknown as { value: '' };
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) {
    this.apiEndPoint = this.settingsService.settings.SPECTRUM_API;
    this.route.data.subscribe(data => {
    });
  }

  getData(): Observable<ReportModel> {
    return this.http.get<ApiResponse>(`${this.apiEndPoint}/${this.key}/report`).pipe(map(s => s.data));
  }

  getChartUrls(): Observable<ChartUrls> {
    return this.http.get<ChartUrls>(`${this.apiEndPoint}/${this.key}/chart-urls`);
  }

}
